import {
  comparedPickerSharedStyle,
} from '@bingads-webui-react/quick-date-left-right-picker';

export const getSubPageMenuStyles = (subPageMenu, { palette = {} }) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 0,
    height: 58,
    overflow: 'auto',
    whiteSpace: 'nowrap',
    alignItems: 'stretch',
    backgroundColor: palette.white,
    '& .overflow-tab-bar-items': {
      paddingTop: 10,
      '& .icon-button': {
        backgroundColor: palette.white,
      },
    },
    '&.expanded': {
      height: 72,
    },
  },
  pickerContainer: {
    marginTop: '13px',
    marginBottom: '12px',
    marginRight: '16px',
    marginLeft: 'auto',
    '&.expanded': {
      marginTop: '8px',
    },
    '&.with-left-margin': {
      marginLeft: 8,
    },
    '& .history-item': {
      fontSize: '18px',

      '& button.history': {
        border: 'none',
        backgroundColor: 'transparent',
        '& .iconba-History': {
          marginRight: '10px',
          fontSize: '18px',
          color: palette.blue,
        },
      },
    },
    '& .recommendation-download-button': {
      top: 2,
      backgroundColor: 'transparent',
      border: 'none',
      fontSize: 18,
      padding: 'unset',
      minWidth: 'unset',
      height: 'fit-content',
      color: palette.themeDarkAlt,
    },
    '& .recommendation-auto-apply-item': {
      top: 5,
      position: 'relative',
    },
  },
  pickerQuickContainer: {
    ...(comparedPickerSharedStyle || {}),
  },
  subMenuSeperator: {
    height: '1px',
    marginLeft: '0px',
    border: 'none',
    backgroundColor: palette.neutralLighter,
  },
  summaryButton: {
    display: 'inline',
    verticalAlign: 'top !important',
    marginTop: '4px !important',
    marginBottom: '4px !important',
  },
});
